import { render, staticRenderFns } from "./stafftimesheets.vue?vue&type=template&id=054f4dee&"
import script from "./stafftimesheets.vue?vue&type=script&lang=js&"
export * from "./stafftimesheets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports